import axios, { AxiosHeaders, type AxiosInstance } from 'axios';
import { env } from '$env/dynamic/public';
import { stringifyQuery } from './queryParams';
import type { IHTTPClientHeaders } from './IHTTPClientHeaders';
import type { IHTTPClientOptions } from './IHTTPClientOptions';
import { resolveValue } from './resolveValue';

const PRODUCTION = process.env.NODE_ENV === 'production' || process.env.NODE_ENV === 'staging';

// const STATUS_CODES = {
// 	badRequest: 400,
// 	unauthorized: 401,
// 	unprocessableEntity: 422,
// 	internalServerError: 500
// };

const DEFAULT_OPTS: IHTTPClientOptions = {
	baseURL: env.PUBLIC_SHOP_API_BASE_URL,
	handleClientError: true,
	handleNetworkError: PRODUCTION,
	logoutWhenUnauthorized: true,
	requestLoginWhenUnauthorized: true,
	timeout: 50000,
	trackLoadingRequests: true
};

const DEFAULT_HEADERS: IHTTPClientHeaders = {
	Accept: 'application/json',
	'Content-Type': 'application/json',
	token: env.PUBLIC_SHOP_API_TOKEN as string
};

function registerRequestInterceptors(client: AxiosInstance, options: IHTTPClientOptions): void {
	// Apply runtime configuration values
	client.interceptors.request.use(
		(config) => {
			config.baseURL = resolveValue(options.baseURL);
			return config;
		},
		(error) => {
			throw error;
		}
	);
}

export function createHTTPClient(
	options: Partial<IHTTPClientOptions> = {},
	headers: Partial<IHTTPClientHeaders> = {}
): AxiosInstance {
	const opts: IHTTPClientOptions = Object.assign({}, DEFAULT_OPTS, options);
	const hdrs: IHTTPClientHeaders = Object.assign({}, DEFAULT_HEADERS, headers);

	const client = axios.create({
		timeout: opts.timeout,
		// TODO: improve typing here
		headers: hdrs as unknown as AxiosHeaders,
		paramsSerializer: stringifyQuery,
		validateStatus: (status) => {
			// only throw for error codes in the 500 range
			return status < 501;
			// TODO participant booking returns 500 when participant has already booked the same event and date
			// better throw for 400 range
		}
	});

	registerRequestInterceptors(client, opts);

	return client;
}
